<template>
  <fabButton v-bind="buttonConfig" :innerContentTheme="calculatorConfig.theme">
    <template #content>
      <Calculator
        :width="calculatorConfig.size"
        :theme="calculatorConfig.theme"
        :productTypes="calculatorConfig.productTypes"
        :customerOptions="calculatorConfig.customerOptions"
        :disableVouchers="calculatorConfig.disableVouchers"
        :onlyThisPage="calculatorConfig.onlyThisPage"
        :promotionCode="calculatorConfig.promotionCode"
        :componentId="calculatorConfig.componentId"
        :reduced="calculatorConfig.reduced"
      />
    </template>
  </fabButton>
</template>

<script setup lang="ts">
// @ts-nocheck
import FabButton, {
  FabButtonProps,
} from 'ewi-ui/components/1-atoms/FabButton/FabButton.vue';
import Calculator, {
  CalculatorProps,
} from 'ewi-ui/components/3-organisms/Calculator/Calculator.vue';

export interface StickyButtonProps extends CalculatorProps {
  config: FabButtonProps;
}

const props = withDefaults(
  defineProps<{
    data: StickyButtonProps;
  }>(),
  {
    data: {
      config: {
        buttonType: 'primary',
        label: 'Tarif berechnen',
        theme: 'dark',
      },
      disableVouchers: '1',
      promotionCode: '0',
      onlyThisPage: '0',
      width: 'half',
      theme: 'dark',
      customerOptions: 'b2c_b2b',
      componentId: '123',
      productTypes: {
        '01': {
          type: '01',
          typeReadable: 'power',
          isSelected: true,
          redirectPage: 'strom/preisberechnung',
          badge: 'Bis zu </br><b>250€</b>Bonus',
        },
        '02': {
          type: '02',
          typeReadable: 'gas',
          isSelected: false,
          redirectPage: 'gas/preisberechnung',
          badge: 'Bis zu </br><b>350€</b>Bonus',
        },
        '03': {
          type: '03',
          typeReadable: 'heatflow',
          isSelected: false,
          redirectPage: 'waermestrom/preisberechnung',
        },
      },
    },
  },
);

const buttonConfig = computed(() => JSON.parse(props.data.config));
const calculatorConfig = computed(() => ({
  ...props.data,
  productTypes: JSON.parse(props.data.productTypes),
}));
</script>
